import { normalizePathSegment } from './normalizePathSegment';
import {
  HOME_SEGMENT,
  sanitizeAdvertisingSegment,
} from './sanitizeAdvertisingSegment';

export { HOME_SEGMENT };

const CONTAINER_PREFIXES = new Set([
  'articles',
  'courses',
  'events',
  'purchase',
  'search',
  'videos',
]);

function resolveCategorySegment({
  siteSubPath = '',
  landingGroupPath = '',
  landingPath = '',
} = {}) {
  const normalizedLandingGroupPath = normalizePathSegment(landingGroupPath);
  const normalizedLandingPath = normalizePathSegment(landingPath);

  if (normalizedLandingGroupPath && normalizedLandingPath) {
    return normalizedLandingPath;
  }

  const normalized = normalizePathSegment(siteSubPath);

  if (!normalized) {
    return HOME_SEGMENT;
  }

  const segments = normalized.split('/');
  const [firstSegment, secondSegment] = segments;

  if (segments.length > 1 && CONTAINER_PREFIXES.has(firstSegment)) {
    return secondSegment || firstSegment;
  }

  if (segments.length > 1) {
    return segments.at(-1);
  }

  return firstSegment;
}

export function getAdvertisingPageCategory(input = {}) {
  const config = typeof input === 'string' ? { siteSubPath: input } : input;

  return sanitizeAdvertisingSegment(resolveCategorySegment(config));
}
